import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';
import { push } from 'react-router-redux';
import { renderExaminationPage, getItems,printExamination,printExaminationWithLayout } from '../examination/render';
import { Button } from 'rmwc';

import * as styles from '../../styles';
import PaginatedContainer from '../../paginator/paginated_container';
import Dialog from '../../dialog/dialog';
import filtersSelectorGenerator from '../examinations/filters';
import { decrementPending, incrementPending, request } from '../../containers/actions';
import { loadExamAnswers } from '../online_examination/online_examination_statics';
import { host, host_v2 } from '../../utilities/requests';
import{setLayoutOptions} from '../examination/actions';

export default class Reports extends React.PureComponent {

    
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    state = {
        topRanks: 0,
        booklet: {},
        currentPage: 0,
        view: 0,
        index: 1,
        showExamInfo: false,
        examInfo: "",
        examId: 0
    }
    
    componentDidUpdate(){
        if(this.state.showExamInfo){
        if(window.innerWidth < 600){
            var elems = document.getElementsByTagName('img');
            for (var i = 0; i<elems.length; i++) {
                elems[i].style.width = '100%';
            }
        }
    }
    }
    GotoUrl(id) {
        var token = this.context.store.getState().get('application').get('token');
        var auth = token.get('accessToken');
        var url = "https://panel.mhelli.com/setmarkers?authToken=" + auth + "&id=" + id;
        window.open(url, '_blank');
    }
    GoToReport(id, title) {
        // report detailReport protest تصحیح مجدد
        var token = this.context.store.getState().get('application').get('token');
        var auth = token.get('accessToken');
        var url = "https://report.mhelli.com/Examination?authToken=" + auth + "&page=" + title + "&examId=" + id;
        window.open(url, '_blank');
    }

    runExam(id, info) {
        if (info !== null && info !== "") {
            this.setState({
                showExamInfo: true,
                examInfo: info,
                examId: id
            });
        }
        else {
            this.submit_runExam(id);
        }
    }
    async submit_runExam(id) {
        this.setState({
            showExamInfo: false,
            examInfo: "",
            examId: 0
        });
        this.context.store.dispatch(push(
            this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            ) + id + '/',
        ));
        const body =  {
                     examId: id,
                     start: true
               }

        const token = this.context.store.getState().getIn(['application', 'token']);
        /* api ثبت زمان شروع آزمون */
        // this.context.store.dispatch(request({
        //     path: `/exam_date_log/`,
        //     body: {
        //         examId: id,
        //         start: true
        //     },
        // }));
        const res = await fetch(host + '/api/exam_date_log/',{
            method: 'POST',
            body: JSON.stringify(body),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                "Authorization": `${token.get('tokenType')} ${token.get('accessToken')}`
            }
        })
        await res.json();
    }
       
    
    style = { items: { itemsList: { width: 'auto', overflowX: 'auto' } } }

    listFieldsSelector = createSelector(
        [
            () => this.context.user,
        ],
        () => [
            ...this.context.user.hasPerm('examination.reports')
                ? [
                    { field: 'id', label: window.gettext('ID') },
                ]
                : [],
            { field: 'title', label: window.gettext('Title') },
            ...this.context.user.is('student')
                ? [
                    {
                        field: item => item.takable ? <button
                            style={{
                                ...styles.defaultButton,
                                padding: '.25em',
                                boxSizing: 'border-box',
                                backgroundColor: styles.fourthColor,
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.runExam(item.id, item.info)
                            }}
                            onMouseUp={({ target }) => target.blur()}>
                            {window.gettext('Run Examination') + (loadExamAnswers(item.id) == null ? '' : '(پاسخنامه ارسال نشده)')}
                        </button>
                            : (item.restricted === false && item.for_sale && (item.beginning === null || item.beginning > Date.now() / 1000)) ?
                                (item.online || item.online === null)
                                    ? window.gettext('Waiting for executing time') : item[(item.restricted ? '' : 'unrestricted_') + 'beginning']
                                        ? item[(item.restricted ? '' : 'unrestricted_') + 'beginning'] > Date.now() / 1000
                                            ? window.gettext('Waiting for executing time')
                                            : (item.register_online === false && item.online === null) ? 'آزمون به صورت کاغذی برگزار می شود '
                                                : window.gettext('Deadline has reached')
                                        : (item.online === null && item.restricted) ? 'آزمون به صورت کاغذی برگزار می شود ' : window.gettext('Deadline has reached')
                                : item.beginning
                                    ? item.beginning > Date.now() / 1000
                                        ? (this.props.type === 1 && item.read_papers > 0 || this.props.type === 2 && item.marked_students > 0) ?
                                            window.gettext('Deadline has reached') : window.gettext('Waiting for executing time')
                                        : (item.register_online === false && item.online === null) ? 'آزمون به صورت کاغذی برگزار می شود ' :
                                            (item.beginning <= Date.now() / 1000 && item.end !== null && item.end > Date.now() / 1000) ?
                                                (this.props.type === 1 && item.read_papers > 0 || this.props.type === 2 && item.marked_students > 0) ?
                                                    window.gettext('Deadline has reached') : window.gettext('Waiting for executing time')
                                                : window.gettext('Deadline has reached')
                                    : item.beginning === null ? window.gettext('Waiting for executing time') : window.gettext('Deadline has reached')
                        , label: window.gettext('Run Examination')
                    },
                ] : [],
            {
                field: item => _.map(item.grades, grade => grade.title).join(window.gettext(',') + ' '),
                label: window.gettext('Grade'),
            },
            { field: item => item.beginning ? item.beginning.toJalali().persian() : '-', label: window.gettext('Date') },
            ...this.context.user.is('student')
                ? []
                : [
                    { field: 'registered', label: window.gettext('Registered') },
                ],
            ...this.props.type === 1
                ? this.context.user.is('student')
                    ? [
                        {
                            field: item => window.pgettext('examination', 'Status-' + ( () => {
                                if(item.read_papers > 0)
                                    return 8;
                                else if(!item.restricted)
                                    return 9;
                                else
                                    return 2;
                            })()),
label: window.gettext('Status'),
                        },
                    ]
                    : [
    { field: 'read_students', label: window.gettext('Read Students') },
]
                : this.context.user.is('student')
    ? [
        {
            field: item => window.pgettext('examination', 'Status-' + ( () => {
                if(item.marked_students === 1)
                    return 8;
                else if(item.read_papers > 0)
                    return 7;
                else
                    return 2;
            })()),
        label: window.gettext('Status'),
                        },
        {
            field: item => `${item.read_papers} ${window.gettext('from')} ${item.pages === null ? '-' : item.pages}`.persian(),
            label: window.gettext('Read Papers'),
        },
        {
            field: item => (
                `${item.marked_questions} ${window.gettext('from')} ` +
                `${item.questions}`.length
            ).persian(),
            label: window.gettext('Marked Questions'),
        },
    ]
    : [
        { field: 'read_students', label: window.gettext('Read Students') },
        {
            field: item => `${item.read_papers} ${window.gettext('from')} ${item.pages * item.read_students}`.persian(),
            label: window.gettext('Read Papers'),
            style: item => item.read_papers < item.pages * item.read_students
                ? {
                    backgroundColor: styles.alertBackColor,
                    color: styles.alertColor,
                }
                : item.read_papers > 0
                    ? {
                        backgroundColor: styles.successBackColor,
                        color: styles.successColor,
                    }
                    : {},
        },
        { field: 'partially_marked_students', label: window.gettext('Marking Students') },
        { field: 'marked_students', label: window.gettext('Marked Students') },
        {
            field: item => (
                `${item.marked_questions} ${window.gettext('from')} ` +
                `${item.questions.length * item.partially_marked_students}`
            ).persian(),
            label: window.gettext('Marked Questions'),
        },
    ],
{
    style: { width: '1px' },
    field: item => (
        this.props.type === 1 && item.read_papers > 0 ||
        this.props.type === 2 && item.marked_students > 0
    )
        ? <button
            style={{
                ...styles.button,
                padding: '.25em',
                boxSizing: 'border-box',
            }}
            onClick={event => {
                event.stopPropagation();
                this.context.store.dispatch(push(
                    this.context.store.getState().getIn(
                        ['routing', 'locationBeforeTransitions', 'pathname'],
                    ) + item.id + '/' + (this.props.module === 'students' ? '' : 'report/'),
                ));
            }}
            onMouseUp={({ target }) => target.blur()}>
            {window.gettext('Report')}
        </button>
        : null,
    label: '',
},
{
    style: { width: '1px' },
    field: item => (
        // item.analyze_date != null &&
        // (this.props.type === 1 && item.read_papers > 0 ||
        // this.props.type === 2 && item.marked_students > 0)
        item.end_of_exam
    )
        ?
        // دکمه دفترچه آزمون برای دانش آموزا
        <button
            style={{
                ...styles.button,
                padding: '.25em',
                boxSizing: 'border-box',
            }}
            onClick={async event => {
                event.stopPropagation();
                const examination = await this.context.store.dispatch(request({
                    path: `/examination/${item.id}/?detailed&all`,
                }));
                this.setState({
                    booklet: examination,
                    currentPage: 0,
                    view: 0,
                    index: 1,
                });
            }}
            onMouseUp={({ target }) => target.blur()}>
            {window.gettext('Booklet')}
        </button>
        : null,
    label: '',
},
            ...this.props.type === 2
    ? [
        {
            style: { width: '1px' },
            field: item => item.read_papers > 0 || item.published_key
                ? <button
                    style={{
                        ...styles.button,
                        padding: '.25em',
                        boxSizing: 'border-box',
                    }}
                    onClick={event => {
                        event.stopPropagation();
                        this.context.store.dispatch(push(
                            this.context.store.getState().getIn(
                                ['routing', 'locationBeforeTransitions', 'pathname'],
                            ) + item.id + (this.context.user.is('student') ? '/paper/' : '/key/'),
                        ));
                    }}
                    onMouseUp={({ target }) => target.blur()}>
                    {this.context.user.is('student') && item.read_papers > 0
                        ? window.gettext('Paper')
                        : window.gettext('Key')
                    }
                </button>
                : null,
            label: this.context.user.is('student')
                ? window.gettext('Paper') + '/' + window.gettext('Key')
                : window.gettext('Key'),
        },
    ]
    : [],

            ...this.props.type === 2 && this.context.user.hasPerm('examination.reports')
    ? [
        {
            style: { width: '1px' },
            field: item => <button
                style={{
                    ...styles.button,
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={event => {
                    event.stopPropagation();
                    this.GotoUrl(item.id);
                }}
                onMouseUp={({ target }) => target.blur()}>
                {window.gettext('Markers')}
            </button>
            ,
            label: window.gettext('Markers')
        },
    ]
    : [],
            ...this.props.type === 2 && this.context.user.hasPerm('examination.reports')
    ? [
        {
            style: { width: '1px' },
            field: item => <button
                style={{
                    ...styles.button,
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={event => {
                    event.stopPropagation();
                    this.GoToReport(item.id, 'detailReport');
                }}
                onMouseUp={({ target }) => target.blur()}>
                {window.gettext('تصحیح مجدد')}
            </button>
            ,
            label: window.gettext('تصحیح مجدد')
        },
    ]
    : [],
            ...this.context.user.hasPerm('examination.reports')
    ? [
        {
            style: { width: '1px' },
            field: item => item.analyze_date
                ? <button
                    style={{
                        ...styles.button,
                        padding: '.25em',
                        boxSizing: 'border-box',
                    }}
                    onClick={async event => {
                        event.stopPropagation();
                        const response = await this.context.store.dispatch(request({
                            path: `/examination/${item.id}/top_ranks/`,
                        }));
                        this.setState({ topRanks: response });
                    }}
                    onMouseUp={({ target }) => target.blur()}>
                    {window.gettext('Top Ranks')}
                </button>
                : null,
            label: '',
        },
    ]
    : [],
            ...this.context.user.is('client') || this.context.user.hasPerm('examination.reports')
    ? [
        {
            style: { width: '1px' },
            field: item => <button
                style={{
                    ...styles.button,
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={event => {
                    event.stopPropagation();
                    this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + item.id + '/schools/',
                    ));
                }}
                onMouseUp={({ target }) => target.blur()}>
                {window.gettext('Schools')}
            </button>,
            label: '',
        },
    ]
    : [],
            ...this.context.user.is('manager') || this.context.user.is('client') || this.context.user.is('teacher') || this.context.user.hasPerm('examination.reports')
    ? [
        {
            style: { width: '1px' },
            field: item => <button
                style={{
                    ...styles.button,
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={event => {
                    event.stopPropagation();
                    this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + item.id + '/students/',
                    ));
                }}
                onMouseUp={({ target }) => target.blur()}>
                {window.gettext('Students')}
            </button>,
            label: '',
        },
    ]
    : [],
            ...this.props.type === 2 && this.context.user.hasPerm('examination.complaints')
    ? [
        {
            style: { width: '1px' },
            field: item => <button
                style={{
                    ...styles.button,
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={event => {
                    event.stopPropagation();
                    this.GoToReport(item.id, 'protest');
                }}
                onMouseUp={({ target }) => target.blur()}>
                {window.gettext('Complaints')}
            </button>,
            label: '',
        },
    ]
    : [],
            ...this.props.type === 1 && this.context.user.hasPerm('examination.complaints')
    ? [
        {
            style: { width: '1px' },
            field: item => <button
                style={{
                    ...styles.button,
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={event => {
                    event.stopPropagation();
                    this.context.store.dispatch(push(`/reports/${item.id}/complaints/`));
                }}
                onMouseUp={({ target }) => target.blur()}>
                <span style={{ color: item.unseen_complaints > 0 ? styles.alertColor : styles.successColor }}>
                    {window.gettext('Complaints')} {item.unseen_complaints.persian()} / {item.complaints.persian()}
                </span>
            </button>,
            label: '',
        },
    ]
    : [],
        ],
    )

examinationFiltersSelector = createSelector(
    [
        _.identity,
        () => this.context.user,
        () => this.props.online,
    ],
    /* TODO */
    (store, user, online) => user.is('student') && online
        ? filtersSelectorGenerator.bind(this)('', { registered: ['True'] })(store)
            : filtersSelectorGenerator.bind(this)('', { registered: ['True'], years: 'default' })(store)
).bind(this)

filtersSelector = createSelector.bind(this)(
    [
        store => this.examinationFiltersSelector(store),
        () => this.context.user,
        () => this.props.type,
        () => this.props.online,
        () => this.props.store.getIn(['gradesTreeFilter']),
    ],
    (filters, user, type, online) => [
        ..._.filter(filters, filter => this.context.user.hasPerm('examination.reports') || !_.includes([
            'online',
            'restricted',
            'registered',
        ], filter.field)),
        ...type
            ? [{ field: 'type', selected: { [type]: null } }]
            : [],
        ...user.is('student')
            ? [
                { field: 'registered_or_participated', selected: { True: null } },
            ]
            : [],
        ...user.is('manager') || user.is('client') || user.is('teacher')
            ? [{ field: 'registered', selected: { True: null } }]
            : [],
        ...user.hasPerm('examination.complaints')
            ? [
                {
                    field: 'complaints',
                    selected: { True: null },
                },
            ]
            : [],
    ],
)

sorts = [
    { name: 'id', label: window.gettext('ID'), reversed: true },
    { name: 'title', label: window.gettext('Title') },
    { name: 'date', label: window.gettext('Date') },
]

events = {
    onClick: item => {
        if (!this.context.user.hasPerm('examination.admin'))
            return;
        this.context.store.dispatch(push(
            this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            ) + item.id + '/description/',
        ));
    },
}

constructor(props, context) {
    super(props, context);
    this.tooltip = this.tooltip.bind(this);
}

tooltip(item) {
    return this.context.user.hasPerm('examination.get') ? (item.note || '').persian() : '';
}

 async componentDidMount(){

    // const df = await request({
    //     path: `/api/server_time/`,
    //     body: {
    //         examId: 854,
    //         start: true
    //     },
    // })
}

render() {
    const pages = this.state.booklet
        ? _.max(_.map(getItems(this.state.booklet, this.state.view), item => item.page) || 0) + 1
        : null;
    return <span>
        {this.props.children ? null : <span>
            <PaginatedContainer
                store={this.props.store.get('paginator')}
                resource='examination'
                style={this.style}
                fixedColumns={2}
                listFields={this.listFieldsSelector(this.props.store)}
                tooltip={this.tooltip}
                title={window.gettext('Examinations Bank')}
                selectable={this.selectable}
                events={this.events}
                filters={this.filtersSelector(this.props.store)}
                sorts={this.sorts}
                pageSize={this.props.pageSize}
                actions={this.props.actions}
                buttonActions={this.props.buttonActions}
            />
        </span>}
        <Dialog isOpen={this.state.showExamInfo}>
            <div style={{ display: 'inline-block', width: '100%', direction: 'ltr', padding: '.5em' }}>

                {this.state.showExamInfo ? <div style={{ direction: 'rtl' }}>
                    <div>
                        {this.state.examInfo}
                    </div>
                    <div style={{ float: 'right', width: '100%', display: 'flex', marginTop: '10px' }}>
                        <button
                            className='king55'
                            style={{
                                ...styles.defaultButton,
                                float: 'left',
                                marginBottom: '.5em',
                                marginRight: '.5em',
                                backgroundColor: styles.fourthColor,
                                opacity: 1,
                                pointerEvents: 'auto'
                            }}
                            onClick={() => { this.submit_runExam(this.state.examId) }
                            }>
                            متوجه شدم
                        </button>
                    </div>
                </div> : null}
            </div>
        </Dialog>
        {/* //this is the ("دفترچه آزمون") section */}
        <Dialog
            isOpen={_.size(this.state.booklet) > 0}
            easyCancel={false}
            onClose={() => this.setState({ booklet: {} })}>
            <div style={{ userSelect: 'none', height: '36em' }}>
                <div
                    style={styles.PDialogStyle}>
                        {
                            this.state.view == 1 ?
                            <button style={{
                                ...styles.button,
                                padding: '.25em',
                                boxSizing: 'border-box',
                                backgroundColor: 'rgb(50, 50, 255)',
                                width: '150px',
                                height: '50px',
                                color:'rgb(244, 244, 244)',
                            }}  
                            onClick={() => {
                            this.context.store.dispatch(incrementPending());
                            printExaminationWithLayout(
                                {...this.state.booklet, layout: this.state.booklet.layout},
                                {
                                    source: this.state.view,
                                    contentProcessors: this.contentProcessors,
                                },()=>{
                                    this.context.store.dispatch(decrementPending());
                                }
                            )
                            }}>
                                پرینت پاسخ نامه</button>
                            : null
                        }
                    <Dialog

                        isOpen={this.state.dialog}
                        onClose={() => this.setState({ dialog: false })}>
                        <span
                            style={{ width: "90%", whiteSpace: "pre-wrap", overflowY: "scroll", minHeight: "300px" }}
                        >
                            <div
                                style={{ width: "100%", whiteSpace: "pre-wrap", overflowY: "scroll", minHeight: "300px" }}
                                dangerouslySetInnerHTML={{
                                    __html: this.state.dialogItem
                                        ? this.state.view === 0
                                            ? this.state.dialogItem.answer_content
                                            : this.state.dialogItem.question_content
                                        : '',
                                }}
                                >
                            </div>
                            <br />
                            <div style={styles.dialogButtonContainer}>
                                <button
                                    style={styles.dialogButton}
                                    onClick={() => this.setState({ dialog: false })}>
                                    {window.gettext('Close')}
                                </button>
                            </div>
                        </span>
                        <span>{this.state.view === 0 ? window.gettext('Answer') : window.gettext('Question')}</span>
                    </Dialog>
                    {/* دکمه متن پاسخ */}
                    {_.isArray(this.state.booklet.questions)
                        ? <span style={{ zoom: '1.13' }} id='ExamAnswers'>
                            {renderExaminationPage(
                                this.state.booklet,
                                this.state.currentPage,
                                {
                                    source: this.state.view,
                                    complementary: item => <span
                                        onClick={() => this.setState({ dialog: true, dialogItem: item })}
                                        style={{
                                            position: 'absolute',
                                            cursor: 'pointer',
                                            top: '.2cm',
                                            fontSize: '.85em',
                                            color: 'blue',
                                            [_.includes(item.content, 'english-ltr') ? 'right' : 'left']: '100%',
                                            [_.includes(item.content, 'english-ltr') ? 'marginRight' : 'marginLeft']: '1mm',
                                            transformOrigin: '0 100%',
                                            transform: 'rotateZ(90deg)',
                                            whiteSpace: 'nowrap',
                                        }}>
                                        {this.state.view === 0 ? window.gettext('Answer Text') : window.gettext('Question Text')}
                                    </span>,
                                },
                            )}
                        </span>
                        : null
                    }
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Button
                        style={{ ...this.state.view === 0 ? styles.defaultButton : styles.button, padding: '0' }}
                        onClick={() => this.setState({ view: 0 })}>
                        {window.gettext('Questions')}
                    </Button>
                    &nbsp;
                    <Button
                        style={{ ...this.state.view === 1 ? styles.defaultButton : styles.button, padding: '0' }}
                        onClick={() => this.setState({ view: 1 })}>
                        {window.gettext('Answers')}
                    </Button>
                    &nbsp;
                    <Button
                        style={{
                            opacity: this.state.currentPage > 0 ? undefined : '0',
                            pointerEvents: this.state.currentPage > 0 ? undefined : 'none',
                        }}
                        onClick={() => this.setState({
                            currentPage: this.state.currentPage - 1,
                            index: this.state.currentPage,
                        })}>
                        <i className='fa-chevron-right'></i>
                    </Button>
                    <input
                        style={{
                            ...styles.field,
                            width: '3em',
                            display: 'inline-block',
                            textAlign: 'center',
                            marginBottom: undefined,
                        }}
                        value={this.state.index.persian()}
                        onChange={({ target: { value } }) => {
                            const index = Number(value.english());
                            if (
                                !value ||
                                index &&
                                index > 0 &&
                                index < pages
                            )
                                this.setState({ index });
                        }}
                        onKeyPress={event => {
                            if ((event.keyCode || event.charCode) == 13)
                                this.setState({ currentPage: this.state.index - 1 });
                        }}
                    />
                    <Button
                        style={{
                            opacity: this.state.currentPage < pages - 1 ? undefined : '0',
                            pointerEvents: this.state.currentPage < pages - 1 ? undefined : 'none',
                        }}
                        onClick={() => this.setState({ currentPage: this.state.currentPage + 1, index: this.state.currentPage + 2 })}>
                        <i className='fa-chevron-left'></i>
                    </Button>
                </div>
            </div>
            <i
                style={{ float: 'right', cursor: 'pointer' }}
                className='fa-times fa-lg'
                onClick={() => this.setState({ booklet: {} })}>
            </i>
        </Dialog>
        <Dialog
            isOpen={Boolean(this.state.topRanks)}
            easyCancel
            onClose={() => this.setState({ topRanks: undefined })}>
            <div style={{ width: '50em' }}>
                {_.map(
                    _.sortBy(this.state.topRanks, 'rank'),
                    row => <div>
                        {row.rank.persian()}. {row.firstname} {row.lastname} ({row.username.persian()}) -
                        &nbsp;
                        {row.school_name} - {row.city_name} - {row.region_name}
                    </div>,
                )}
            </div>
            {window.gettext('Top Ranks')}
        </Dialog>
        {this.props.children}
    </span>;
}
}
window.pgettext('examination', 'Status-1');
window.pgettext('examination', 'Status-2');
window.pgettext('examination', 'Status-3');
window.pgettext('examination', 'Status-4');
window.pgettext('examination', 'Status-5');
window.pgettext('examination', 'Status-6');
window.pgettext('examination', 'Status-7');
window.pgettext('examination', 'Status-8');
window.pgettext('examination', 'Status-9');
